import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "color"];
var __jsx = React.createElement;
import React from 'react';
const AirplaneFromTopIcon = _ref => {
  let {
      size = "13",
      color = "currentColor"
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  return __jsx("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 25 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, attributes), __jsx("path", {
    d: "M7.5 23.875L10 23.875L16.25 13.875L23.125 13.875C23.6223 13.875 24.0992 13.6775 24.4508 13.3258C24.8025 12.9742 25 12.4973 25 12C25 11.5027 24.8025 11.0258 24.4508 10.6742C24.0992 10.3225 23.6223 10.125 23.125 10.125L16.25 10.125L10 0.124999L7.5 0.124999L10.625 10.125L3.75 10.125L1.875 7.625L-2.23518e-06 7.625L1.25 12L-2.61766e-06 16.375L1.875 16.375L3.75 13.875L10.625 13.875L7.5 23.875Z",
    fill: color
  }));
};
export default AirplaneFromTopIcon;